import { useSyncExternalStore } from 'react'
import { getBlockingState, subscribeBlocking } from '../utils/blockingStore'

export const useBlockingStore = () => {
  return useSyncExternalStore(
    subscribeBlocking,
    getBlockingState,
    () => ({ count: 0 })
  )
}

